import React, { useState, useEffect } from "react";
import "../Surveys.css";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//paparse
import { parse } from "papaparse";

//components
import SurveyNational from "../../reusable/SurveyNational/SurveyNational";

//assets
import TEXT from "../../../utils/text/surveys_national.json";

async function getData(url) {
  const data = parse(await fetchCsv(url), { header: true });
  return data.data;
}

async function fetchCsv(url) {
  const response = await fetch(url);
  const reader = response.body.getReader();
  const result = await reader.read();
  const decoder = new TextDecoder("utf-8");
  const csv = decoder.decode(result.value);
  return csv;
}

export default function Brazil({ survey }) {
  //language
  const { language } = useCurrentLanguage();

  //useState - data
  const [data, setData] = useState([]);

  //useState - questions
  const [questions, setQuestions] = useState([]);

  //useEffect
  useEffect(() => {
    if (survey !== "") handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [survey]);

  //handle get data
  const handleGetData = async () => {
    const csv1 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}brazil_q1.csv`
    );
    const csv2 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}brazil_q2.csv`
    );

    const csv3 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}brazil_q3.csv`
    );

    const csv4 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}brazil_q4.csv`
    );

    const csv5 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}brazil_q5.csv`
    );

    const y_data1 = Object.keys(csv1[0]).filter((e) => e !== "Afirmacion");
    const x_data1 = csv1.map((e) => e["Afirmacion"]);
    const series1 = y_data1.map((e, i) => {
      return x_data1.map((el) =>
        Number(csv1.find((e) => e["Afirmacion"] === el)[y_data1[i]])
      );
    });
    const data1 = [y_data1, x_data1, series1];

    const y_data2 = Object.keys(csv2[0]).filter((e) => e !== "Afirmacion");
    const x_data2 = csv2.map((e) => e["Afirmacion"]);
    const series2 = y_data2.map((e, i) => {
      return x_data2.map((el) =>
        Number(csv2.find((e) => e["Afirmacion"] === el)[y_data2[i]])
      );
    });
    const data2 = [y_data2, x_data2, series2];

    const y_data3 = Object.keys(csv3[0]).filter((e) => e !== "Afirmacion");
    const x_data3 = csv3.map((e) => e["Afirmacion"]);
    const series3 = y_data3.map((e, i) => {
      return x_data3.map((el) =>
        Number(csv3.find((e) => e["Afirmacion"] === el)[y_data3[i]])
      );
    });
    const data3 = [y_data3, x_data3, series3];

    const y_data4 = Object.keys(csv4[0]).filter((e) => e !== "Afirmacion");
    const x_data4 = csv4.map((e) => e["Afirmacion"]);
    const series4 = y_data4.map((e, i) => {
      return x_data4.map((el) =>
        Number(csv4.find((e) => e["Afirmacion"] === el)[y_data4[i]])
      );
    });
    const data4 = [y_data4, x_data4, series4];

    const y_data5 = Object.keys(csv5[0]).filter((e) => e !== "Afirmacion");
    const x_data5 = csv5.map((e) => e["Afirmacion"]);
    const series5 = y_data5.map((e, i) => {
      return x_data5.map((el) =>
        Number(csv5.find((e) => e["Afirmacion"] === el)[y_data5[i]])
      );
    });
    const data5 = [y_data5, x_data5, series5];

    let temp = [
      {
        id: "q1",
        question: TEXT["BRA"]["q1"]["question"][language],
        source: TEXT["BRA"]["q1"]["source"][language],
        description: TEXT["BRA"]["q1"]["description"][language],
        narrative: TEXT["BRA"]["q1"]["narrative"][language],
        data: data1,
        graphType: "s_h_bar",
        hasOptions: false,
        isLarge: true,
        survey: TEXT["BRA"]["q1"]["survey"][language],
        link: TEXT["BRA"]["q1"]["link"],
      },
      {
        id: "q2",
        question: TEXT["BRA"]["q2"]["question"][language],
        source: TEXT["BRA"]["q2"]["source"][language],
        description: TEXT["BRA"]["q2"]["description"][language],
        narrative: TEXT["BRA"]["q2"]["narrative"][language],
        data: data2,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["BRA"]["q2"]["survey"][language],
        link: TEXT["BRA"]["q2"]["link"],
      },
      {
        id: "q3",
        question: TEXT["BRA"]["q3"]["question"][language],
        source: TEXT["BRA"]["q3"]["source"][language],
        description: TEXT["BRA"]["q3"]["description"][language],
        narrative: TEXT["BRA"]["q3"]["narrative"][language],
        data: data3,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["BRA"]["q3"]["survey"][language],
        link: TEXT["BRA"]["q3"]["link"],
      },
      {
        id: "q4",
        question: TEXT["BRA"]["q4"]["question"][language],
        source: TEXT["BRA"]["q4"]["source"][language],
        description: TEXT["BRA"]["q4"]["description"][language],
        narrative: TEXT["BRA"]["q4"]["narrative"][language],
        data: data4,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["BRA"]["q4"]["survey"][language],
        link: TEXT["BRA"]["q4"]["link"],
      },
      {
        id: "q5",
        question: TEXT["BRA"]["q5"]["question"][language],
        source: TEXT["BRA"]["q5"]["source"][language],
        description: TEXT["BRA"]["q5"]["description"][language],
        narrative: TEXT["BRA"]["q5"]["narrative"][language],
        data: data5,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["BRA"]["q5"]["survey"][language],
        link: TEXT["BRA"]["q5"]["link"],
      },
    ];

    let tempQ = [];
    temp.forEach((e) => {
      if (e.survey === survey) tempQ.push({ code: e.id, label: e.question });
    });
    setData(temp.filter((el) => el.survey === survey));
    setQuestions(tempQ);
  };

  return (
    <div>
      <SurveyNational data={data} questions={questions} title={survey} />
    </div>
  );
}
